module.controller('feesCtrl', ['$stateParams', 'brandService', function($stateParams, brandService) {

  var vm = this;
  var brand = brandService.getBrand($stateParams.brand);

  var offset = 1;

  // FeeDisclosurePosition: counter to display the superscript number
  // in the fee list
  if (typeof brand.fees !== 'undefined') {
    for (var i = 0; i < brand.fees.length; i++) {
      if (brand.fees[i].FeeDisclosure) {
        brand.fees[i].FeeDisclosurePosition = offset;
        offset++;
      }
    }
  }

}]);
